import React from 'react';
import { choose } from '../../utils/platform';
import { useRegister } from './useRegister';
import RegisterDesktop from './Register.desktop';
import RegisterMobile from './Register.mobile';
import '../../styles/people.css';

const RegisterView = choose(RegisterDesktop, RegisterMobile);

export default function Register() {
  const vm = useRegister();
  return <RegisterView vm={vm} />;
}
